// extracted by mini-css-extract-plugin
export default {"item":"DragDropItem_item__x1XY+","item_isDragging":"DragDropItem_item_isDragging__LfIfG","handle":"DragDropItem_handle__VVGPA","row":"DragDropItem_row__Bb+z7"};